import React from 'react';

import styled from 'styled-components';

import ShopRequestCommunitiesSelector from './ShopRequestCommunitiesSelector';
import ShopRequestModalCommunityRows from './ShopRequestModalCommunityRows';
import ShopRequestModalInfo from './ShopRequestModalInfo';
import ShopRequestModalSourceSelector from './ShopRequestModalSourceSelector';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-flow: column;
  height: 100%;
  min-height: 0;
  width: 100%;
`;

const StyledCommunitiesInfoContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

const CommunitiesContainer = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-flow: column;
  min-height: 0;
  min-width: 0;
`;

const InfoContainer = styled.div`
  border-left: solid 1px var(--line-gray);
  flex: 0 0 30%;
  max-width: 370px;
  min-width: 320px;
`;

const CreateShopRequestModalContent = () => {
  return (
    <Container>
      <ShopRequestModalSourceSelector />
      <StyledCommunitiesInfoContainer>
        <CommunitiesContainer>
          <ShopRequestCommunitiesSelector />
          <ShopRequestModalCommunityRows />
        </CommunitiesContainer>
        <InfoContainer>
          <ShopRequestModalInfo />
        </InfoContainer>
      </StyledCommunitiesInfoContainer>
    </Container>
  );
};

export default CreateShopRequestModalContent;
